import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { capitaliseText, isNotEmpty } from "../../../helpers/StringHelpers"
import { HouseNumberValidator } from "../../../services/validation/address-employment-form/HouseNumberValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const HouseNumberField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        errorText,
        isDisabled,
    } = props

    const [errorMessage, setErrorMessage] = useState(``)
    const [value, setValue] = useState(defaultValue ?? ``)

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
        setValue(defaultValue ?? ``)
    }, [defaultValue, errorText])

    const validateField = (value: string) => {
        const validator = new HouseNumberValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }
    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const text = event.target.value
        const REGEX = /^[a-zA-Z0-9]+$/g
        if (text === `` || REGEX.test(text)) {
            setValue(capitaliseText(text))
            handleChange(capitaliseText(text))
        }
    }
    const handleOnBlur = (event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
        validateField(event.target.value)
    }

    return (
        <TextField
            error={isNotEmpty(errorMessage)}
            fullWidth
            id="house-number"
            label={t(`house_number`)}
            value={value}
            inputProps={{ maxLength: 5 }}
            helperText={t(errorMessage)}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            disabled={isDisabled}
        />
    )
}

export { HouseNumberField }